import React, { useEffect, useState, useCallback } from 'react'
import HealtheraTable from '../Table/Table'
import GeozonesMap from './GeozonesMap'
import { Flex, Box } from 'reflexbox'
import { AlignRight, HeaderContainer, HeaderTitle, BackButton, BounceAnimatedContainer, PaperContainer, HorizontalRule, ContainerRight, ColoredText, HealtheraButton } from '../../healtheraComponents'
import styled from 'styled-components'
import { useSelector, useDispatch } from "react-redux"
import * as actions from '../../redux/geozones'
import * as branchActions from '../../redux/branches'
import { withRouter } from 'react-router'
import LegacyBranchesDialog from '../LegacyBranchesDialog/LegacyBranchesDialogContainer'
import DynamicForm from '../DynamicForm/DynamicForm'
import { Schema } from './InputSchema'
import set from 'set-value'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import ArrowDown from '@material-ui/icons/ArrowDownward'
import ArrowUp from '@material-ui/icons/ArrowUpward'

const GeozoneDetails = (props) => {
  const { geozone, geozone: { name, _id, pharmacies, code, note } } = useSelector(state => state.geozones)
  const [dialog, setDialog] = useState(false)
  const [openView, setOpenView] = useState(false)
  const dispatch = useDispatch()
  const geozoneID = props.match.params.regionID;
  const [schema, setSchema] = useState({})

  // Be careful with using useEffect, massive memory leaks will be introduced if you don't understand them
  useEffect(() => {
    // Downloads all the polygons
    dispatch(actions.getGeozone(geozoneID))
  }, [dispatch, geozoneID])

  useEffect(() => {
    setSchema(Schema({ name, code, note }))
  }, [name, code, note])

  const handleAddingPharmacy = () => {
    dispatch(branchActions.getAllBranches())
    setDialog(true)
  }

  const goBack = () => {
    props.history.push(`${process.env.PUBLIC_URL}/regions`)
  }

  const handleSubmit = async ({ name, code, note }) => {
    await dispatch(actions.updateGeozone(geozone._id, { name, code, note }))
    await dispatch(actions.getGeozone(geozone._id))
  }

  const onChange = (props, geozone) => {
    set(geozone, props.field, props.value)
  }

  const handleDrawerClick = useCallback(() => setOpenView(!openView), [openView])

  return (
    <>
      <BounceAnimatedContainer>
        <HeaderContainer padding={`20px 0 20px 0`} onClick={goBack} borderbottom={`none`} p={2} align='center'>
          <BackButton padding={`0 5px 0 0`} />
          <HeaderTitle cursor={`pointer`} px={2} w={1 / 3}>Regions</HeaderTitle>
        </HeaderContainer>
        <PaperContainer elevation={0}>
          <HeaderContainer marginright={`0px`} padding={`0 0 20px 0`}>
            <HeaderTitle fontSize={`24px`}>{name}</HeaderTitle>
            <ContainerRight>{_id}</ContainerRight>
          </HeaderContainer>
          <br />
          <LegacyBranchesDialog
            open={dialog}
            onClose={async (pharmacy) => {
              setDialog(false)
              if (pharmacy && pharmacy.geozoneID !== _id) {
                if (pharmacy.geozoneID) {
                  if (window.confirm("This pharmacy is added already in another region. Are you sure you to add it here?"))
                    await dispatch(branchActions.updateBranch(pharmacy._id, { ...pharmacy, geozoneID: _id }))
                } else await dispatch(branchActions.updateBranch(pharmacy._id, { ...pharmacy, geozoneID: _id }))
                await dispatch(actions.getGeozone(geozoneID))
              }
            }}
          />
          {openView && <>
            <GeozonesMap pharmacies={pharmacies} />
            <HorizontalRule />
            <Box w={`50%`}>
              <Flex align='center'>
                <DynamicForm title={'Geozone Settings'}
                  save={() => handleSubmit(geozone)}
                  editable
                  displayButtons
                  margintop={`5px`}
                  defaultValue={schema.zone}
                  onChange={(props) => onChange(props, geozone)}
                  fields={schema.zone} />
              </Flex>
            </Box>
          </>}
          <DrawerContainer>
          <Drawer onClick={handleDrawerClick}>
            {openView ? <ArrowUp /> : <ArrowDown />}
          </Drawer>
          </DrawerContainer>
        </PaperContainer>
      </BounceAnimatedContainer>
      <AlignRight>
        <LinkText onClick={handleAddingPharmacy}>Link an existing pharmacy to a region</LinkText>
      </AlignRight>
      <br />
      {pharmacies && <TabbedTables pharmacies={pharmacies} history={props.history} geozoneID={geozoneID} />}
    </>
  )
}

export default withRouter(GeozoneDetails)

export const TabbedTables = (props) => {

  const [tab, setTab] = useState(0)
  const [pharmacies, setPharmacies] = useState(props.pharmacies)

  useEffect(() => {
    switch (tab) {
      case 1:
        setPharmacies(props.pharmacies.filter(pharmacy => pharmacy.delivery_partner?.rx_referral_commission))
        break
      case 2:
        setPharmacies(props.pharmacies.filter(pharmacy => !pharmacy.delivery_partner?.rx_referral_commission))
        break
      default:
        setPharmacies(props.pharmacies)
    }
  }, [tab, props.pharmacies])
  const dispatch = useDispatch()

  const prepareData = (pharmacies = []) => {
    return pharmacies.reduce((data, pharmacy) => {
      const {
        _id,
        chain_id,
        organisationID,
        delivery_partner,
        pharmacy_name,
        status, postcode = {},
        commissionableCount,
        organisation,
      } = pharmacy

      const referralPharmacy = delivery_partner?.rx_referral_commission || false
      const orgName = organisation?.name || '';
      let orgID = chain_id || organisationID

      const goToOrg = e => {
        e.stopPropagation()
        props.history.push(`/organisations/${orgID}`)
      }

      data.push({
        view: {
          name: pharmacy_name || '',
          orgName: orgName ? <LinkText onClick={goToOrg}>{orgName}</LinkText> : '',
          postcode: postcode || '',
          active: ['premium', 'free'].includes(status) ? <ColoredText color='#2f9d6d'>Active</ColoredText> : 'Inactive',
          referral: referralPharmacy ? 'Referral Pharmacy' : '',
          cpc: commissionableCount
        },
        ID: _id,
        button: {
          title: 'Remove', onClick: async (e) => {
            e.stopPropagation()
            if (window.confirm(`Are you sure you want to remove ${pharmacy.pharmacy_name} from this region? `)) {
              await dispatch(branchActions.updateBranch(_id, { geozoneID: null }))
              await dispatch(actions.getGeozone(props.geozoneID))
            }
          }
        },
        route: 'branches'
      })
      return data
    }, [{
      view: {
        name: 'Pharmacy Name',
        orgName: 'Organisation Name',
        postcode: 'Postcode',
        active: 'Active',
        referral: 'Referral',
        cpc: 'Commissionable Patients'
      },
      headers: true
    }])
  }

  return (
    <>
      <Tabs value={tab} onChange={(e, v) => { setTab(v) }} >
        <Tab label="ALL" value={0} />
        <Tab label="Referral Pharmacies" value={1} />
        <Tab label="Non Referral Pharmacies" value={2} />
      </Tabs>
      <HealtheraTable history={props.history} muted={true} data={prepareData(pharmacies)} />
    </>
  )
}



const LinkText = styled.button`
&&
{
  position: ${props => props.position ? props.position : `unset`};
  font-family: Assistant;
  background:none;
  border:0;
  font-size: 16px;
  right: 0;
  color: #2f9d6d;
  top: 0;
  cursor:pointer;
}
`
const DrawerContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Drawer = styled(HealtheraButton)`
&&
{
  width: 500px;
}
`
